<div class="modal-header bg-dark text-white">
  <h3 class="modal-title">Import Contacts from Excel</h3>
  <div class="ms-auto" data-bs-theme="dark">
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>
<div class="modal-body">
  <ol class="mb-3">
    <li>
      <span [hidden]="loadingTemplate">
        Download the <a (click)="downloadTemplate($event)" href="#" class="fw-bold">Contact Import Template</a>
      </span>
      <span [hidden]="!loadingTemplate" class="text-muted">Preparing your template&hellip;</span>
    </li>
    <li>Add your supplier contacts to the template</li>
    <li>Upload the completed file below</li>
  </ol>

  <div class="alert alert-info small">
    New contacts receive an email invitation to activate their JetFuelTenders account.
    Contacts who already have an account are simply added to your list.
    This does not invite anyone to a tender. Up to 300 contacts per file.
  </div>

  <jft-dropzone (filesSelected)="filesSelected($event)" [loading]="loading">
    Drop excel file here
  </jft-dropzone>
</div>
<div class="modal-footer">
  <button class="btn btn-light" (click)="close()">Close</button>
</div>
